<div *ngIf="formObject" [ngClass]="[formObject.class || '']">
  <div *ngIf="(getFormHeaderHidden() | async) === false" [class]="['flex flex-col w-full p-2']">
    <!-- Header -->
    <div class="space-y-1 py-5 sm:py-0">
      <h1 class="text-2xl font-bold tracking-tight md:text-3xl">
        {{ formObject.title | translate }}
      </h1>
      <p class="text-md text-muted-color">{{ formObject.description || '' | translate }}</p>
    </div>
    <hr class="mt-4 mb-4 lg:mb-6" />
  </div>

  <div
    [ngClass]="['flex gap-4 xl:gap-10', formObject.orientation === 'vertical' ? 'flex-col xl:flex-row' : 'flex-col']">
    <div *ngFor="let grid of formObject.grids"
      [ngClass]="['flex w-full', formObject.orientation === 'vertical' ? 'flex-row xl:flex-col gap-10' : 'flex-col gap-4']">
      <div *ngIf="(getGridHeaderHidden(grid) | async) === false" class="flex flex-col w-full p-2">
        <!-- Grid Header -->
        <div class="space-y-1 py-2 border-b">
          <h2 class="text-2xl font-bold tracking-tight md:text-3xl">
            {{ grid.title | translate }}
          </h2>
          <p *ngIf="grid.description" class="text-md text-muted-color">{{ grid.description | translate }}</p>
        </div>
      </div>

      <div class="flex flex-col w-full">
        <!-- Filtered Grid Items -->
        <ng-container *ngIf="filterVisibleRows(grid.gridItems) | async as visibleRows">
          <div *ngFor="let item of visibleRows">
            <ng-container *ngIf="getVisibleFieldCount(item) | async as visibleCount">
              <div [ngClass]="[
                  'grid gap-6 w-full mb-5',
                  item.class || '',
                  formObject.orientation === 'vertical' || visibleCount === 1
                    ? 'grid-cols-1'
                    : visibleCount === 2
                      ? 'grid-cols-1 lg:grid-cols-2'
                      : visibleCount === 3
                        ? 'grid-cols-1 lg:grid-cols-2 xl:grid-cols-3'
                        : visibleCount === 4
                          ? 'grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4'
                          : '',
                ]">
                <!-- Field -->
                <ng-container *ngFor="let field of item.fields">
                  <div [ngClass]="['flex', 'flex-col', 'gap-2', 'w-full', field.class || '']"
                    *ngIf="(isHidden(field) | async) === false">
                    <label for="input-{{ field.label }}"
                      [ngClass]="['block', 'text-sm', 'font-medium', field.labelClass || '']">
                      {{ field.label || '' | translate }}
                      <span *ngIf="field.isRequired" class="text-red-500">*</span>
                    </label>
                    <sm-field-builder [field]="field"></sm-field-builder>
                    <div class="flex justify-between gap-2">
                      <p class="text-xs text-muted-color">{{ field.description || '' | translate }}</p>
                    </div>
                  </div>
                </ng-container>
              </div>
            </ng-container>
          </div>
        </ng-container>
      </div>
    </div>

    <div *ngIf="formObject.showLegend" class="flex justify-between gap-2 items-center">
      <p class="text-xs text-muted-color">
        {{ 'common.required' | translate }}
      </p>
    </div>
  </div>
</div>